import {
    MEASUREMENT_TYPE_IMPERIAL,
    MEASUREMENT_TYPE_METRIC,
    SET_MEASUREMENT_TO_IMPERIAL, SET_MEASUREMENT_TO_METRIC,
} from '../constants';

const defaultState = {
    measurementType: localStorage.getItem('MEASUREMENT_TYPE') || MEASUREMENT_TYPE_METRIC
};

export const measurement = (state = defaultState, action) => {
    const { type } = action;
    switch (type) {
        case SET_MEASUREMENT_TO_METRIC:
            localStorage.setItem('MEASUREMENT_TYPE', MEASUREMENT_TYPE_METRIC.toString());

            return {
                ...state,
                measurementType: MEASUREMENT_TYPE_METRIC
            };
        case SET_MEASUREMENT_TO_IMPERIAL:
            localStorage.setItem('MEASUREMENT_TYPE', MEASUREMENT_TYPE_IMPERIAL.toString());
            return {
                ...state,
                measurementType: MEASUREMENT_TYPE_IMPERIAL
            };
        default:
            return state;
    }
};
